/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Smarts
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Exception for smarts-js.
*/


export default class SmartsException extends Error {

	constructor(status, details) {
		//TODO Localised the message
		super('Smarts request failed');
		this.status = status;
		this.details = details;
	}

}